import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteNotificationSettingModalProps {
    settingId: string | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteNotificationSettingModal = ({
    settingId,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteNotificationSettingModalProps) => {
    const visible = Boolean(settingId);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, settingId]);

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete this notification?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>You are about to delete this email notification setting. Recipients will no longer be notified at this threshold.</p>
        </CustomModal>
    );
};
